import Vue from 'vue'
import Router from 'vue-router'
//import auth from '@/auth/authService'
import Store from "./store/store";

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [

		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: '',
			component: () => import('./layouts/main/Main.vue'),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				{
					path: '/',
					redirect: '/dashboard/analytics'
				},
				{
					path: '/dashboard/analytics',
					name: 'dashboard-analytics',
					component: () => import('./views/DashboardAnalytics.vue'),
					meta: {
						rule: 'public'
					},

				},


				// =============================================================================
				// Application Routes
				// =============================================================================


				{
					path: '/current-accounts',
					name: 'customer',
					component: () => import('./views/customer/CustomerList.vue'),
					meta: {
						meta: {
							breadcrumb: [
								{ title: 'Home', url: '/' },
								{ title: 'Pages' },
								{ title: 'Invoice', active: true }
							],
							pageTitle: 'Invoice',
						},
						rule: 'admin'
					}
				},
				{
					path: '/current-transactions',
					name: 'customer',
					component: () => import('./views/customer/CustomerTransactions.vue'),
					meta: {
						rule: 'admin'
					}
				},
				{
					path: '/progress-billing',
					name: 'customer',
					component: () => import('./views/customer/ProgressBilling.vue'),
					meta: {
						rule: 'admin'
					}
				},
				{
					path: '/collection',
					name: 'customer',
					component: () => import('./views/customer/Collection.vue'),
					meta: {
						rule: 'admin'
					}
				},
				{
					path: '/current-reports',
					name: 'customer',
					component: () => import('./views/customer/CustomerReports.vue'),
					meta: {
						rule: 'admin'
					}
				},
				{
					path: '/storehouse-list',
					name: 'storehouse',
					component: () => import('./views/storehouse/StorehouseList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/inventory-definitions',
					name: 'stock',
					component: () => import('./views/stock/StockList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					mode: 'hash',
					path: '/marketplace-to-stock',
					name: 'stock-to-marketplace',
					component: () => import('./views/stock/StrockTransToMarketplace.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/match-stock',
					name: 'match-stock',
					component: () => import('./views/stock/MatchStock.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/bundle-stock',
					name: 'bundle-stock',
					component: () => import('./views/stock/BundleProduct.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/inventory-movements',
					name: 'inventory-movements',
					component: () => import('./views/stock/StockMovements.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/shelf-operations',
					name: 'stock',
					component: () => import('./views/stock/ShelfOperations.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/add-stock-shelf',
					name: 'add-stock-shelf',
					component: () => import('./views/stock/AddStockToShelf.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/add-stock-shelf-serial',
					name: 'add-stock-shelf-serial',
					component: () => import('./views/stock/AddStockToShelfWithSerial.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/barcode-printing',
					name: 'stock',
					component: () => import('./views/stock/BarcodePrinting.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/barcode-printing-modules/:data?/:copy?',
					name: 'barcode-printing-modules',
					component: () => import('./views/stock/BarcodePrintModules.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/matched-stock',
					name: 'MatchedStockList',
					component: () => import('./views/stock/MatchedStockList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					mode: 'hash',
					path: '/movement-stock',
					name: 'StockMovement',
					component: () => import('./views/stock/StockMovementAddNew.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/inventory-counting',
					name: 'stock',
					component: () => import('./views/stock/InventoryCounting.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/inventory-counting-item/:data?',
					name: 'inventory-counting-item',
					component: () => import('./views/stock/InventoryCountingItem.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-list',
					name: 'order',
					component: () => import('./views/order/OrderList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-picking',
					name: 'order',
					component: () => import('./views/order/OrderPicking.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-picking-product-scan/:collection',
					name: 'order-picking-product-scan',
					component: () => import('./views/order/OrderPickingProductScan.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/product-packaging',
					name: 'order',
					component: () => import('./views/order/OrderPackaging.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/product-packaging-product-scan/:collection/:marketplace',
					name: 'product-packaging-product-scan',
					component: () => import('./views/order/OrderPackingProductScan.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/completed-orders',
					name: 'order',
					component: () => import('./views/order/CompletedOrders.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-status',
					name: 'order-status',
					component: () => import('./views/order/OrderStatusForCompany.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/order-reports',
					name: 'order',
					component: () => import('./views/order/OrderReports.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/shipment-work-order',
					name: 'procurement',
					component: () => import('./views/procurement/ShipmentWorkOrder.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/expertize/:data?',
					name: 'expertize',
					component: () => import('./views/procurement/Expertize.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/expertize-list',
					name: 'expertize-list',
					component: () => import('./views/procurement/ExpertizeList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/expertize-sheme',
					name: 'expertize-sheme',
					component: () => import('./views/procurement/ExpertizeShemeList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/product-receipt',
					name: 'procurement',
					component: () => import('./views/procurement/ProductReceipt.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/procurement-barcode-printing',
					name: 'procurement',
					component: () => import('./views/procurement/BarcodePrinting.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/general-definitions',
					name: 'definitions',
					component: () => import('./views/definitions/GeneralDefinitions.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/warehouse-definitions',
					name: 'definitions',
					component: () => import('./views/storehouse/StorehouseList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/supplier-definitions',
					name: 'definitions',
					component: () => import('./views/definitions/SupplierDefinitions.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/shelf-definitions',
					name: 'definitions',
					component: () => import('./views/definitions/ShelfDefinitions.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/user-definitions',
					name: 'definitions',
					component: () => import('./views/definitions/UserDefinitions.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/contract-definitions',
					name: 'definitions',
					component: () => import('./views/definitions/ContractDefinitions.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/report-management',
					name: 'definitions',
					component: () => import('./views/definitions/ReportManagement.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/faq',
					name: 'faq',
					component: () => import('./views/support/Faq.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/how-to-use',
					name: 'HowToUse',
					component: () => import('./views/support/HowToUse.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/usage/:title',
					name: 'usage',
					component: () => import('./views/support/Usage.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					mode: 'hash',
					path: '/tracking-addnew',
					name: 'stocktrackingaddnew',
					component: () => import('./views/stockTracking/StockTrackingAddNew.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					mode: 'hash',
					path: 'tracking-stock',
					name: 'stocktracking',
					component: () => import('./views/stockTracking/StockTrackingList.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/user',
					name: 'user',
					component: () => import('./views/user/User.vue'),
					meta: {
						rule: 'public'
					}
				},
				{
					path: '/role',
					name: 'role',
					component: () => import('./views/apps/role/Role.vue'),
					meta: {
						rule: 'public'
					}
				},


			]
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: '',
			component: () => import('@/layouts/full-page/FullPage.vue'),
			children: [

				{
					path: '/login',
					name: 'page-login',
					component: () => import('@/views/pages/login/Login.vue'),
					meta: {
						rule: 'public'
					}
				},


			]
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	]
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})
/*
router.beforeEach((to, from, next) => {
	firebase.auth().onAuthStateChanged(() => {

		// get firebase current user
		const firebaseCurrentUser = firebase.auth().currentUser

		// if (
		//     to.path === "/pages/login" ||
		//     to.path === "/pages/forgot-password" ||
		//     to.path === "/pages/error-404" ||
		//     to.path === "/pages/error-500" ||
		//     to.path === "/pages/register" ||
		//     to.path === "/callback" ||
		//     to.path === "/pages/comingsoon" ||
		//     (auth.isAuthenticated() || firebaseCurrentUser)
		// ) {
		//     return next();
		// }

		// If auth required, check login. If login fails redirect to login page
		if (to.meta.authRequired) {
			if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
				router.push({ path: '/pages/login', query: { to: to.path } })
			}
		}

		return next()
		// Specify the current path as the customState parameter, meaning it
		// will be returned to the application after auth
		// auth.login({ target: to.path });

	})

})*/

export default router
